module.exports = __webpack_public_path__ + "img/grey_003.6c42a664.png";